import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subscriptionButton'
})
export class SubscriptionButtonPipe implements PipeTransform {
  transform(value: string, args: string): string {
    switch (value) {
      case 'basic.annually':
      case 'basic.monthly':
        if (args === 'pro') return 'Upgrade';
        return args === 'basic' ? 'Current' : 'Downgrade';
      case 'pro.annually':
      case 'pro.monthly':
        if (args === 'basic') return 'Downgrade';
        return args === 'pro' ? 'Current' : 'Upgrade';
      default:
        return 'Upgrade';
    }
    // upgrade if lower than plan
    // downgrade if higher than plan
  }
}
